module.exports = __webpack_public_path__ + "static/media/mag4.23c8053a.jpeg";